import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getIndexOfHighestValue = (arr: string[]) => {
  if (arr.length === 0) {
    return -1; // Or handle as an error
  }

  const numericArr = arr.map(Number);
  const maxVal = Math.max(...numericArr);
  return numericArr.indexOf(maxVal);
};

export function normalizeFilterValue(value: string) {
  return value
    .trim()
    .toLowerCase()
    .replace(/\./g, "") // Remove dots
    .replace(/\s+/g, "_");
}

export const safeBase64Encode = (str: string): string => {
  const bytes = new TextEncoder().encode(str);
  let binary = "";
  for (const b of bytes) binary += String.fromCodePoint(b);
  return btoa(binary);
};
